import type { ChatMessage } from '@/api/chat';

/**
 * День сообщения — по нему чаты сотрудника на телефоне рисуют разделитель «Сегодня» / «12 октября» (`StaffBubble`).
 * Отдельным файлом, а не рядом с компонентом: файл с компонентом и функцией ломает быстрое обновление Vite
 * (`react-refresh/only-export-components`).
 */
export function chatDayOf(msg?: ChatMessage): string {
  if (!msg?.created_at) return '';
  return new Date(msg.created_at).toDateString();
}
